import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Select, Button, TextInput, Checkbox } from 'advenio-components'
import { Form } from 'formsy-react' //eslint-disable-line
import PaymentsActions from '../../../Data/Redux/ParentPlatform/PaymentsRedux'
import UnvalidatedReceiptsActions from '../../../Data/Redux/UnvalidatedReceiptsRedux'
import ChildrenActions, { Selectors as ParentChildSelectors } from '../../../Data/Redux/ParentPlatform/ChildrenRedux'
import { clone, concat, isEmpty, isNil } from 'ramda'


const Container = styled(Form)`
  width: 100%;
  display: flex;
  padding: 24px;
  box-sizing: border-box;
  justify-content: center;
  flex-direction: column;
`

const Submit = styled(Button)`
  width: 200px;
`

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`
const BalanceContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`

const NoCardsContainer = styled.div`
width: 100%;
height: 200px;
display: flex;
justify-content: space-around;
align-items: center;
font-size: 24px;
color: #8e8a8a;
flex-direction: column;
@media (max-width:763px) {
  height: 200px;
  font-size: 20px;
  padding: 16px;
  box-sizing: border-box;
  text-align: center;
}
`

const Span = styled.span`
  font-size: 20px;
  font-weight: bold;
`


class PaymentModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: window.innerWidth,
      cards: [{ label: '', id: 0, value: 0 }],
      balance: 0,
      symbol: '$',
      code: 'MXN',
      noCards: false,
      total:0,
      showPaymentMSI:false,
      paid_all:false,
      optionsMSI: [],
      has_payment_msi:false
    }
  }

  componentWillMount = () => {
    const { cards, child:{ has_payment_msi }, child } = this.props
    if (cards) {
      if (cards.authorized.length > 0) {        
        const newCards = cards.authorized.filter(card => isNil(card.deleted_at) || isEmpty(card.deleted_at))
        .map(card => ({
          value: card.id,
          label: `${card.card_brand}  ${card.last_four}  ${card.is_default ? '(Default)' : ''}`,
          id: card.id,
          default: card.is_default,
        }))
        this.setState({ cards: newCards })
      } else {
        this.setState({ noCards: true })
      }
    } else {
      this.setState({ noCards: true })
    }
    if (child.outstanding_balance) {
      this.setState({
        balance: child.outstanding_balance,
        symbol: child.currency.symbol,
        code: child.currency.code,
      })
    }
    this.setState({has_payment_msi})
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount = () => {
    this.setState({paid_all:false, has_payment_msi:false, showPaymentMSI:false, total:0})
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions = () => {
    const width = window.innerWidth
    this.setState({ width })
  }

  submit = (model) => {
    const { card, amount, paid_all, payment_type_msi } = model
    let data = {
      card_id: card,
      total: amount,
    }
    if(paid_all){
      if(Number(payment_type_msi) > 0){
        data = {
          ...data,
          payment_type_msi
        }
      }
    }
    this.props.createParentPayment(this.props.child.id, data)
  }

  getValue = () => {
    const { cards } = this.state
    if (cards.value !== 0) {
      for (let i = 0; i < cards.length; i++) {
        if(isNil(cards[i].deleted_at) || isEmpty(cards[i].deleted_at)) continue
        if (cards[i].default) {
          return cards[i].value
        }
      }
    }
    return cards[0].value
  }

  sendToAccount = () => {
    this.props.onClose()
    this.props.sendToAccount()
  }

  handleChange = (model) => {
    const { totalBalance } = this.props
    const  { paid_all } = model
    const total = paid_all ?  Number(totalBalance) : 0

    this.setState({total, paid_all: model.paid_all})
    this.handleTotal({"target":{"value":total}}, model.paid_all)
  }

  handleChange = (model) => {
    const { paymentTypesMsi } = this.props
    const { balance } = this.state
    const  { paid_all } = model

    const total = paid_all ? balance : 0

    let showPaymentMSI = false
    let optionsMSI = [{id:0, label:"Pago en una sola exhibición",value:0}]
    if(paid_all !== undefined && paid_all){
      showPaymentMSI = true
    }

    if(total >= 300){
      const paymentsMsi =  paymentTypesMsi.filter(p => total >= p.amount_limit) || []
      if(! isEmpty(paymentsMsi)){
        const paymentsTypes =   clone(paymentsMsi.map(paymentMsi => ({
          id: paymentMsi.id
          ,label: paymentMsi.name
          ,value: paymentMsi.id
        })))
        optionsMSI = concat(optionsMSI,paymentsTypes)
      }
      // if(total>=300){
      //   const paymentMsi = paymentTypesMsi.filter(p => p.monthly_installments === 3) || []
      //   !isEmpty(paymentMsi) ?
      //     optionsMSI.push({id:paymentMsi[0].id, label:paymentMsi[0].name,value:paymentMsi[0].id})
      //   :null
      // }
      // if(total>=600){
      //   const paymentMsi = paymentTypesMsi.filter(p => p.monthly_installments === 6) || []
      //   !isEmpty(paymentMsi) ?
      //     optionsMSI.push({id:paymentMsi[0].id, label:paymentMsi[0].name,value:paymentMsi[0].id})
      //   :null
      // }
      // if(total>=900){
      //   const paymentMsi = paymentTypesMsi.filter(p => p.monthly_installments === 9) || []
      //   !isEmpty(paymentMsi) ?
      //     optionsMSI.push({id:paymentMsi[0].id, label:paymentMsi[0].name,value:paymentMsi[0].id})
      //   :null
      // }
      // if(total>=1200 ){
      //   const paymentMsi = paymentTypesMsi.filter(p => p.monthly_installments === 12) || []
      //   !isEmpty(paymentMsi) ?
      //     optionsMSI.push({id:paymentMsi[0].id, label:paymentMsi[0].name,value:paymentMsi[0].id})
      //   :null
      // }
      // if(total>=1800 ){
      //   const paymentMsi = paymentTypesMsi.filter(p => p.monthly_installments === 18) || []
      //   !isEmpty(paymentMsi) ?
      //     optionsMSI.push({id:paymentMsi[0].id, label:paymentMsi[0].name,value:paymentMsi[0].id})
      //   :null
      // }
    }
    this.setState({showPaymentMSI, optionsMSI, total, paid_all})

  }

  render() {
    const { width, cards, balance, symbol, code, noCards, total, paid_all, optionsMSI, has_payment_msi } = this.state
    return (
      <Container
        onSubmit={this.submit}
        onChange={this.handleChange}
      >
        {noCards ?
          <NoCardsContainer>
            <span>Favor de agregar una tarjeta para poder pagar</span>
            <Button ghost onClick={this.sendToAccount}>Agregar tarjeta</Button>
          </NoCardsContainer>
          :
          <div>
            <BalanceContainer>
              <Span>Balance</Span>
              <span>{symbol}{balance}{code}</span>
            </BalanceContainer>
            <Select
              name="card"
              label="Selecciona tu tarjeta"
              value={this.getValue()}
              options={cards}
            />
            <TextInput
              name="amount"
              label="Monto a pagar"
              prefix={symbol}
              suffix={code}
              value={total}
              disabled={paid_all}
            />
            { paid_all && (
              <Select
                name="payment_type_msi"
                label="Meses sin interes"
                value={0}
                options={optionsMSI}
              />)}
            {has_payment_msi  && balance >= 300 && (
            <Checkbox
              name="paid_all"
              label="Pagar Todo (Meses sin intereses)"
              invertedColors
              large
              hideEmptyHelpBlock
              value={false}
             //  disabled={this.state.disabled}
            />)}
            <ButtonContainer>
              <Submit type="submit" primary loading={this.props.loading} >Pagar</Submit>
              {/* <Button primary onClick={this.paidAll}>Pagar Todo</Button> */}
            </ButtonContainer>
          </div>
        }
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  loading: state.parent_platform_payments.sending.fetching,
  student: ParentChildSelectors.activeChild(state) &&
  ParentChildSelectors.activeChild(state).student,
  paymentTypesMsi: state.payment_types_msi.get.results
})


const mapDispatchToProps = dispatch => ({
  createParentPayment: (id, data) => dispatch(PaymentsActions.createPaymentRequest(id, data)),
  sendToAccount: () => dispatch(UnvalidatedReceiptsActions.sendToAccount()),
})

export default connect(mapStateToProps,mapDispatchToProps)(PaymentModal)



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/PaymentModal/index.jsx